<template>
  <v-container>
    <form @submit.prevent="updateHealthRecord">
      <v-card flat class="mt-7 pa-5">
        <v-toolbar flat width="100%">
          <v-toolbar-title class="text-h4">{{$t('animal.healthRecord')}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            @click="cancelpage"
            outlined
            right
            height="44"
            width="116"
            color="primary"
          >
            {{$t('cancel')}}
          </v-btn>
          <v-btn
            right
            class="ml-5"
            height="44"
            width="116"
            color="primary"
            type="submit"
          >
            {{$t('submit')}}
          </v-btn>
        </v-toolbar>
      </v-card>
      <v-expansion-panels focusable class="mt-5" v-model="panel">
        <v-expansion-panel>
          <v-expansion-panel-header class="text-h6 font-weight-bold"
            >{{$t('animal.healthRecord')}}</v-expansion-panel-header
          >
          <v-expansion-panel-content class="pt-5">
            <v-row>
              <v-col cols="6">
                <label class="label">{{$t('animal.healthRecordInfo.treatment')}}
                      <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                              mdi-information-outline
                          </v-icon>
                          </template>
                          <span
                          >{{$t('animal.healthRecordInfo.treatmentTakenAnimal')}}.</span
                          >
                      </v-tooltip>
                  </label>
                <v-text-field
                  type="text"
                  outlined
                  dense
                  :placeholder="$t('animal.healthRecordInfo.treatment')"
                  v-model="animalHealth.treatment"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <label class="label">{{$t('animal.healthRecordInfo.reasonOfTreatment')}}
                      <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                              mdi-information-outline
                          </v-icon>
                          </template>
                          <span
                          >{{$t('animal.healthRecordInfo.whatReasonOfTreatment')}}.</span
                          >
                      </v-tooltip>
                  </label>
                <v-text-field
                  type="text"
                  outlined
                  dense
                  :placeholder="$t('reason')"
                  v-model="animalHealth.treatmentReason"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <label class="label">{{$t('animal.healthRecordInfo.treatmentDate')}} <span class="red--text">*</span>
                      <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                              mdi-information-outline
                          </v-icon>
                          </template>
                          <span
                          >{{$t('animal.healthRecordInfo.dateOfTreatment')}}.</span
                          >
                      </v-tooltip>
                  </label>
                <v-menu
                  v-model="treatmentDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="animalHealth.treatmentDate"
                      append-icon="mdi-calendar"
                      outlined
                      dense
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      v-on:click:append="treatmentDateMenu=true"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="animalHealth.treatmentDate"
                    @input="treatmentDateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="6">
                <label class="label">{{$t('animal.healthRecordInfo.diagnosis')}}
                      <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                              mdi-information-outline
                          </v-icon>
                          </template>
                          <span
                          >{{$t('animal.healthRecordInfo.nameDiagnosedDiseaseConditionSymptoms')}}.</span
                          >
                      </v-tooltip>
                  </label>
                <v-text-field
                  type="text"
                  outlined
                  dense
                  :placeholder="$t('animal.healthRecordInfo.diagnosis')"
                  v-model="animalHealth.diagnosis"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <label class="label">{{$t('animal.healthRecordInfo.drugID')}}
                      <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                              mdi-information-outline
                          </v-icon>
                          </template>
                          <span
                          >{{$t('animal.healthRecordInfo.iDOfDrugWhichIsGivenToAnimal')}}.</span
                          >
                      </v-tooltip>
                  </label>
                <v-text-field
                  type="text"
                  outlined
                  dense
                  placeholder="#DR387291"
                  v-model="animalHealth.drugId"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <label class="label">{{$t('animal.healthRecordInfo.drugName')}}
                      <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                              mdi-information-outline
                          </v-icon>
                          </template>
                          <span
                          >{{$t('animal.healthRecordInfo.nameDrugAnimal')}}.</span
                          >
                      </v-tooltip>
                  </label>
                <v-text-field
                  type="text"
                  outlined
                  dense
                  :placeholder="$t('animal.genotypeDataInfo.nameOfTheDrug')"
                  v-model="animalHealth.drugName"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <label class="label">{{$t('animal.healthRecordInfo.drugWithdrawalPeriod')}}
                      <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                              mdi-information-outline
                          </v-icon>
                          </template>
                          <span
                          >{{$t('animal.healthRecordInfo.timeAdministrationDrugAnimalMeatMilkHumanConsumption')}}.</span
                          >
                      </v-tooltip>
                  </label>
                <v-text-field
                  type="text"
                  outlined
                  dense
                  :placeholder="`2 ${$t('days')}`"
                  v-model="animalHealth.drugWithdrawPeriod"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <label class="label">{{$t('animal.healthRecordInfo.attendingVeterinarian')}}
                      <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                              mdi-information-outline
                          </v-icon>
                          </template>
                          <span
                          >{{$t('animal.healthRecordInfo.qualifiedPersonCaseAnimal')}}.</span
                          >
                      </v-tooltip>
                  </label>
                <v-text-field
                  type="text"
                  outlined
                  dense
                  :placeholder="$t('animal.healthRecordInfo.veterinarianName')"
                  v-model="animalHealth.attendingVeterinarian"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <label class="label">{{$t('animal.healthRecordInfo.packID')}}
                      <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                              mdi-information-outline
                          </v-icon>
                          </template>
                          <span
                          >{{$t('animal.healthRecordInfo.iDPackTreatment')}}.</span
                          >
                      </v-tooltip>
                  </label>
                <v-text-field
                  type="text"
                  outlined
                  dense
                  placeholder="#PACK28716"
                  v-model="animalHealth.packId"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <div class="d-flex justify-end">
        <v-btn
          @click="cancelpage"
          outlined
          right
          height="44"
          width="116"
          color="primary"
          class="mr-2 mt-15"
        >
          {{$t('cancel')}}
        </v-btn>
        <v-btn
          right
          class="mt-15"
          height="44"
          width="116"
          color="primary"
          type="submit"
        >
          {{$t('submit')}}
        </v-btn>
      </div>
    </form>
    <DataLostWarning
        :dialogI="dataLossWarning"
        v-if="dataLossWarning"
        @closeDialog="closeWarningMessage"
        @saveData="closeWarningMessage"  
    ></DataLostWarning>
  </v-container>
</template>

<script>
// import { weightUnits, milkUnits, birthEaseTypes, totalLongevity, timeUnits } from "@/models/units.js"

import AnimalService from "@/_services/AnimalService";
import loading from "@/mixins/LoadingMixin";

export default {
  created() {
    const fetchData = async () => {
      await this.getAnimalHealthRecord();
    };
    fetchData();
  },
  beforeRouteLeave(to, from, next) {
		if(this.formChanged) {
			this.promptToRoute = to;
			this.dataLossWarning = true;
			return
		}
		next();
	},
  watch: {
    animalHealth: {
      handler() {
        this.formChanged = true;
      },
      deep: true
    },
  },
  data() {
    return {
      dataLossWarning: false,
      formChanged: false,
      promptToRoute: null,
      panel: 0,
      healthRecordRegistered: false,
      treatmentDateMenu: false,
      animalHealth: {
        animalNumber: this.$route.params.animal_number,
        treatment: "",
        treatmentReason: "",
        treatmentDate: new Date(
          Date.now() - new Date().getTimezoneOffset() * 60000
        )
          .toISOString()
          .substr(0, 10),
        diagnosis: "",
        drugId: "",
        drugName: "",
        drugWithdrawPeriod: "",
        attendingVeterinarian: "",
        packId: "",
      },
    };
  },
  methods: {
    closeWarningMessage(stay) {
      this.dataLossWarning = false;
      if(!stay) {
        this.formChanged = false;
        this.$router.push(this.promptToRoute)
      }
    },
    cancelpage() {
      this.$router.push({
        name: "AnimalHealthReord",
        params: { animal_number: this.$route.params.animal_number },
      });
    },

    async getAnimalHealthRecord() {
      this.startLoading();
      AnimalService.getAnimalHealthRecord(this.$route.params.animal_number)
        .then((res) => {
          if (res.success) {
            if (res.data.healthRecord) {
              this.animalHealth = res.data.healthRecord;
              this.healthRecordRegistered = true;
            }
            this.stopLoading();
          }
        })
        .catch((err) => {
          console.log("err", err.data);
          this.stopLoading();
        });
    },
    updateHealthRecord() {
      this.startLoading();
      this.formChanged = false;
      AnimalService.updateAnimalHealthRecord(
        this.animalHealth,
        this.healthRecordRegistered
      )
        .then((res) => {
          var msg = "Added";
          if (this.healthRecordRegistered) {
            res = res.data;
            msg = "Updated";
          }
          // console.log('rk',res)
          if (res.success) {
            this.$notify({
              title: `Animal Health Record ${msg} Successfully`,
              text: res.message,
              type: "success",
              position: "top right",
            });
          } else {
            this.$notify({
              title: `Animal Health Record Not ${msg}`,
              text: res.message,
              type: "error",
              position: "top right",
            });
          }
          this.stopLoading();
          this.cancelpage();
        })
        .catch((err) => {
          console.log(err.data);
          this.stopLoading();
        });
    },
  },
  mixins: [loading],
};
</script>
<style lang="scss" scopped>
label {
  display: inline-block;
  margin-bottom: 0.5rem;
  font-size: 14px;
  font-family: Poppins-Medium;
  letter-spacing: 0.5px;
  white-space: nowrap;
}
</style>